<template>
  <div class="about-container">
    <div class="about-center">
      <p class="about-theme">{{themeText}}</p>
      <p class="about-theme-en">{{themeEnText}}</p>
      <p class="fontSize12 about-version">{{version}}</p>
    </div>
    <div class="about-bottom" v-if="!isHiddenBrand">
      <p class="customerService">{{$t('about.客服热线')}}：{{ customerService }}</p>
      <div class="about-links">
        <a :href="policyUrl" target="_blank" class="maincolor">{{$t('about.隐私声明')}}</a>
        &nbsp;|&nbsp;
        <a :href="termsUrl" target="_blank" class="maincolor">{{$t('about.用户政策')}}</a>
      </div>
      <p>{{$t('about.北京二六三企业通信有限公司')}}</p>
      <p>
       Copyright©1998-<span
          >{{ new Date().getFullYear() }} All Right Reserved</span
        >
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "about",
  data() {
    return {
      customerService: config.customerService,
      policyUrl: config.policyUrl,
      termsUrl: config.termsUrl,
      version:config.version
    };
  },
  computed: {
    isHiddenBrand() {
      return this.$store.state.defaultInfo.isHiddenBrand 
    },
    themeText() {
      return this.isHiddenBrand ? this.$t('about.云播') : this.$t('about.263云播')
    },
    themeEnText() {
      return this.isHiddenBrand ? 'ClouldLive' : '263 ClouldLive'
    }
  },
};
</script>

<style  lang="scss" scoped>
.about-container {
  background-color: #2d304f;
  height: 432px;
  position: relative;
  text-align: center;
  .about-center {
    position: absolute;
    height: 70px;
    right: 0;
    left: 0;
    top: 94px;
    margin: auto;
    .about-theme {
      font-size: 21px;
      &-en {
        font-size: 16px;
        color: #ACB2BF;
      }
    }
    p {
      line-height: 25px;
    }
  }
  .about-bottom {
    position: absolute;
    bottom: 10px;
    padding: 0px 45px;
    left: 0;
    right: 0;
    line-height: 20px;
    font-size: 12px;
    color: #ACB2BF;
  }
   .customerService {
    padding: 0px 45px;
    margin: 0 auto 30px;
    font-size: 14px;
    color: #ACB2BF;
  }
}
.about-links {
  margin-bottom: 13px;
  font-size: 14px;
  a {
    text-decoration: none;
  }
}
</style>
